import React, {useEffect, useState} from 'react';
import {BoxTitle} from "../../components/front/BoxTitle";
import {Reglement} from "../../components/front/Reglement";
import pdf from "../../assets/images/pdf.png";
import {useAppDispatch, useAppSelector} from "../../redux/store";
import {document} from "../../models/document";
import {fetchData as fetchDocument} from "../../redux/document_reducer";
import {documentHydrator} from "../../models/hydrator/documentHydrator";
import {TableLineLoader} from "../../components/front/loader/TableLineLoader";
import {ApiService} from "../../service/ApiService";
import {settingResultType} from "../../types/Api/SettingResultType";
import DateService from "../../service/DateService";

// Découpe les documents en rangées : un document « nouvelle ligne » ouvre une nouvelle rangée
const rows = (documents: document[]): document[][] => {
  return documents.reduce((acc: document[][], d: document) => {
    if (acc.length === 0 || d.lineBreak) {
      acc.push([]);
    }

    acc[acc.length - 1].push(d);

    return acc;
  }, []);
}

export const Licence = () => {
  const dispatch = useAppDispatch();

  const documents: document[] = useAppSelector((state) => state.document.data);
  const loading: boolean = useAppSelector((state) => state.document.loading);

  // Année (« 2026 / 2027 »…) et date limite (AAAA-MM-JJ) de la licence, paramétrées dans l'admin
  const [year, setYear] = useState(undefined as undefined | string);
  const [deadline, setDeadline] = useState(undefined as undefined | string);

  useEffect(() => {
    dispatch(fetchDocument());
  }, [dispatch]);

  useEffect(() => {
    (ApiService.get('/setting/licence_year') as Promise<settingResultType>)
      .then((r: settingResultType) => setYear(r.value || undefined))
      .catch(() => setYear(undefined));

    (ApiService.get('/setting/licence_deadline') as Promise<settingResultType>)
      .then((r: settingResultType) => setDeadline(r.value
        ? DateService.toLocaleString(`${r.value}T00:00:00`, {day: 'numeric', month: 'long', year: 'numeric'})
        : undefined))
      .catch(() => setDeadline(undefined));
  }, []);

  return (
    <>
      <div className="__front_box__">
        <BoxTitle title={year ? `Licence ${year}` : 'Licence'}/>

        <div className="font-1_25 text-center mb-5">
          Documents à remplir et à renvoyer à l'adresse indiquée sur le bulletin d'adhésion
        </div>

        {loading && (
          <TableLineLoader/>
        )}

        {!loading && rows(documents).map((row: document[], i: number) => (
          <div key={i} className="mb-5 d-flex justify-content-around text-center">
            {row.map((d: document) => (
              <p key={d.documentId} className="col text-center">
                <a href={documentHydrator.downloadUrl(d)} download={`${d.slug}.pdf`}><img src={pdf} className="img-fluid max-w50px" alt="pdf"/></a>
                <br/>
                {d.label}
              </p>
            ))}
          </div>
        ))}

        <div className="font-1_25 text-center">
          <i className="fa fa-warning me-1" />
          <u>ATTENTION</u> :
          si vous n'avez pas renouvelé votre licence {deadline ? `au plus tard le ${deadline}` : 'à temps'},<br/>
          vous n'êtes plus couvert par l'assurance.
        </div>
      </div>

      <div className="mt-4">
        <Reglement />
      </div>
    </>
  );
}
